/* jshint -W024 */
import Vue from 'vue'
import Router from 'vue-router'
import Axios from '@/api/fetch.js'
import Store from '@/store/index.js'
import types from '@/constants/types.js'
import permissionPathArr from '@/constants/permissionPath.js'

//根页面
const Index = () =>
  import('@/views/Login/Index')
//注册页面
const Regist = () =>
  import('@/views/Login/Regist/index.vue')
// 账户设置页面  
const setting = () =>
  import('@/components/setting/setting2.vue')
//大数据
const bigData = () =>
  import('@/views/Student/SelfTraining/bigData/bigData')
//大数据详情
const bigDataDetail = () =>
  import('@/views/Student/SelfTraining/bigData/bigDataDetail')
// 自主训练
const SelfTraining = () =>
  import('@/views/Student/SelfTraining/index.vue');
// 自主训练 答题界面
const TopicIndex = () =>
  import('@/views/Student/SelfTraining/topic/index');
// 自主训练 预览界面
const PreviewTopic = () =>
  import('@/views/Student/SelfTraining/previewTopic/index')
const SelfTrainStatistics = () =>
  import('@/views/Student/SelfTraining/statisticalScores/SelfTrainStatistics.vue')
// 模拟训练
const SimulatedTraining = () =>
  import('@/views/Student/SimulatedTraining/index.vue')
const simulationTrain = () =>
  import('@/views/Student/SelfTraining/statisticalScores/simulationTrain.vue')
// 模拟训练 题目界面
const SharingTopic = () =>
  import('@/views/Student/SimulatedTraining/sharingTopic/index.vue')
// 模拟训练 选择房间
const checkRoom = () =>
  import('@/views/Student/simulatedTraining/checkRoom')
//模拟训练 我的房间
const myRoom = () =>
  import('@/views/Student/simulatedTraining/myRoom.vue')
// 校内赛
const InnerRace = () =>
  import('@/views/Student/InnerRace/index.vue')
const screen = () =>
  import('@/views/Student/InnerRace/screen')
// 校内赛 加入房间
const joinRoom = () =>
  import('@/views/Student/InnerRace/joinRoom')
// 校内赛 座位房间
const seatRoom = () =>
  import('@/views/Student/InnerRace/seatRoom')
// 校内赛 团队题目界面
const InnerRaceTopic = () =>
  import('@/views/Student/InnerRace/InnerRaceTopic/index.vue')
// 校内赛 个人题目界面
const selfInnerRaceTopic = () =>
  import('@/views/Student/InnerRace/selfInnerRaceTopic/index.vue')
// 首页
const Home = () =>
  import('@/views/Student/Home')
const enroll = () =>
  import('@/views/Student/enroll.vue')
const Login = () =>
  import('@/views/Login/login.vue')
// 子登录页
const HNBK = () =>
  import('@/views/Student/Login/BK_hunan.vue')
const HNGZ = () =>
  import('@/views/Student/Login/BK_hngz.vue')
const HNZZ = () =>
  import('@/views/Student/Login/BK_hnzz.vue')
const GXGZ = () =>
  import('@/views/Student/Login/BK_gxgz.vue')
const GXBK = () =>
  import('@/views/Student/Login/BK_gxbk.vue')
//新版登录
const FinancialData = () =>
  import('@/views/Login/under_Login.vue')
//新版登录
const FinancialIndex = () =>
  import('@/views/Login/under_index.vue')
//教师
const HNBKTEACHERS = () =>
  import('@/views/Teacher/Login/BK_hunan.vue')
const GXGZTEACHERS = () =>
  import('@/views/Teacher/Login/BK_gxgz.vue')
const GXBKTEACHERS = () =>
  import('@/views/Teacher/Login/BK_gxbk.vue')
const testpaper = () =>
  import('@/views/Teacher/TestPaper/testpaper.vue')
const testAllpaper = () =>
  import('@/views/Teacher/TestPaper/testAllpaper.vue')
const StatisticalScores = () =>
  import('@/views/Teacher/StatisticalScores/index.vue')
//教务
const HNBKDEAN = () =>
  import('@/views/Dean/Login/BK_hunan.vue')
const GXGZDEAN = () =>
  import('@/views/Dean/Login/BK_gxgz.vue')
const GXBKDEAN = () =>
  import('@/views/Dean/Login/BK_gxbk.vue')

// //发布任务
// const Task = () =>
//     import('@/views/Dean/NewProject')
//试卷中心
const academicTaskCenter = () =>
  import('@/views/Dean/academic/academicTaskCenter.vue')
// const ExaminationPaper = () =>
//     import('@/views/NewProject/examinationPaper.vue')
//任务中心
const TaskCenter = () =>
  import('@/views/Dean/NewProject/taskCenter.vue')
//查看成绩
const ViewResults = () =>
  import('@/views/Dean/NewProject/sumUp.vue')
//实时监控
const Monitoring = () =>
  import('@/views/Dean/NewProject/monitoring.vue')
// // 校内赛管理
// const CampusRace = () =>
//     import('@/views/NewProject/campusRace.vue')

// 教师统计分析
const StatisticAnalysis = () =>
  import('@/views/Teacher/StatisticalScores/index.vue')
//试卷预览
const PaperPreview = () =>
  import('@/views/Teacher/StatisticalScores/paperPreview.vue')
//首页-中职学生
const secondaryIndex = () =>
  import('@/views/newLogin/secondary/index')
//登录-中职学生
const secondaryLogin = () =>
  import('@/views/newLogin/secondary/login')
//高职学生-首页
const higherIndex = () =>
  import('@/views/newLogin/higher/index')
//高职学生-登录
const higherLogin = () =>
  import('@/views/newLogin/higher/login')

const LoginB = () =>
  import('@/views/Login/loginb')

const LoginZ = () =>
  import('@/views/Login/loginz')

const LoginT = () =>
  import('@/views/Login/Hlogin.vue')
const LoginZZ = () =>
  import('@/views/Login/ZLogin.vue')

Vue.use(Router);

const router = new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: Index,
    redirect: '/Home',
    children: [{
      path: '/selfTraining',
      name: 'selfTraining',
      component: SelfTraining,
    },
    {
      path: '/innerRace',
      name: 'innerRace',
      component: InnerRace,
    },
    {
      path: '/taskCenter',
      name: 'taskCenter',
      component: TaskCenter,
    },
    {
      path: '/viewResults', //查看成绩
      name: 'viewResults',
      component: ViewResults,
    },
    {
      path: '/academicTaskCenter',
      name: 'academicTaskCenter',
      component: academicTaskCenter,
    },
    {
      path: '/simulatedTraining',
      name: 'simulatedTraining',
      component: SimulatedTraining,
    },
    {
      path: '/statisticalScores/SelfTrainStatistics',
      name: 'SelfTrainStatistics',
      component: SelfTrainStatistics,
    },
    {
      path: '/simulatedTraining/checkRoom',
      name: 'checkRoom',
      component: checkRoom,
    },
    {
      path: '/statisticalScores/simulationTrain',
      name: 'simulationTrain',
      component: simulationTrain,
    },
    {
      path: '/setting/setting',
      name: 'setting',
      component: setting,
    },
    {
      path: '/testpaper',
      name: 'testpaper',
      component: testpaper,
    },
    {
      path: '/testAllpaper',
      name: 'testAllpaper',
      component: testAllpaper,
    },
    {
      path: '/StatisticalScores',
      name: 'StatisticalScores',
      component: StatisticalScores,
    },
    {
      path: '/statisticAnalysis',
      name: 'statisticAnalysis',
      component: StatisticAnalysis,
    }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Index,
    children: [
      {
        path: '/LoginIndex',
        component: Login,
      },
      {
        path: 'HNBK/students',
        component: HNBK,
      },
      {
        path: 'HNGZ/students',
        component: HNGZ,
      },
      {
        path: 'HNZZ/students',
        component: HNZZ,
      },
      {
        path: 'GXGZ/students',
        component: GXGZ,
      },
      {
        path: 'GXBK/students',
        component: GXBK,
      },
      {
        path: 'HNBK/teachers',
        component: HNBKTEACHERS,
      },
      {
        path: 'GXGZ/teachers',
        component: GXGZTEACHERS,
      },
      {
        path: 'GXBK/teachers',
        component: GXBKTEACHERS,
      },
      {
        path: 'HNBK/dean',
        component: HNBKDEAN,
      },
      {
        path: 'GXGZ/dean',
        component: GXGZDEAN,
      },
      {
        path: 'GXBK/dean',
        component: GXBKDEAN,
      },
    ]
  },
  {
    path: '/FinancialData',
    component: FinancialData
  },
  {
    path: '/FinancialIndex',
    component: FinancialIndex
  },
  {
    path: '/secondaryIndex',
    component: secondaryIndex,
  },
  {
    path: '/secondaryLogin',
    component: secondaryLogin,
  },
  {
    path: '/higherIndex',
    component: higherIndex,
  },
  {
    path: '/higherLogin',
    component: higherLogin,
  },
  {
    path: '/Loginb',
    component: LoginB,
  },
  {
    path: '/Loginz',
    component: LoginZ,
  },
  {
    path: '/Logint',
    component: LoginT,
  },
  {
    path: '/Loginzz',
    component: LoginZZ,
  },
  {
    path: '/Regist',
    component: Regist,
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/enroll',
    name: 'enroll',
    component: enroll,
  },
  {
    path: '/topic/index',
    name: 'topicIndex',
    component: TopicIndex
  },
  {
    path: '/paperPreview',
    name: 'paperPreview',
    component: PaperPreview
  },
  {
    path: '/previewTopic/index',
    name: 'previewTopic',
    component: PreviewTopic
  },
  {
    path: '/sharingTopic/index',
    name: 'sharingTopic',
    component: SharingTopic
  },
  {
    path: '/bigData',
    name: 'bigData',
    component: bigData,
  },
  {
    path: '/bigDataDetail',
    name: 'bigDataDetail',
    component: bigDataDetail,
  },
  {
    path: '/InnerRace/screen',
    name: 'screen',
    component: screen,
  },
  {
    path: '/InnerRaceTopic/index',
    name: 'innerRaceTopic',
    component: InnerRaceTopic
  },
  {
    path: '/selfInnerRaceTopic/index',
    name: 'selfInnerRaceTopic',
    component: selfInnerRaceTopic
  },
  {
    path: '/simulatedTraining/myRoom',
    name: 'myRoom',
    component: myRoom,
  },

  {
    path: '/monitoring', //实时监控
    name: 'monitoring',
    component: Monitoring,
  },
  {
    path: '/InnerRace/seatRoom',
    name: 'seatRoom',
    component: seatRoom,
  },
  {
    path: '/InnerRace/joinRoom',
    name: 'joinRoom',
    component: joinRoom,
  },
  ]
})

router.beforeEach((to, from, next) => {
  let localStore = Store;
  let targetPath = to.path;
  let userInfo = JSON.parse(sessionStorage.getItem("userInfo")) || {};
  let accessToken = localStore.getters['students/loginData'].AccessToken;
  if (!accessToken && (targetPath != '/Home' && targetPath != '/LoginIndex' && targetPath != '/secondaryIndex' && targetPath != '/secondaryLogin'
    && targetPath != '/higherIndex' && targetPath != '/higherLogin' && targetPath != '/Loginb' && targetPath != '/Loginz' && targetPath != '/Regist' && targetPath != '/Logint' && targetPath != '/Loginzz' && targetPath != '/enroll' && targetPath != '/FinancialData' && targetPath != '/FinancialIndex')) {
    localStore.commit(`students/${types.STUDENTS_LOGINOUT}`)
    return;
  }
  if (accessToken && userInfo.Type == 1 && (targetPath == '/secondaryLogin' || targetPath == '/higherLogin' || targetPath == '/FinancialData' || targetPath == '/Logint' || targetPath == '/Loginzz')) {
    return
  }
  if (accessToken && userInfo.Type == 2 && (targetPath == '/secondaryLogin' || targetPath == '/higherLogin' || targetPath == '/FinancialData' || targetPath == '/Logint' || targetPath == '/Loginzz')) {
    return
  }
  next();
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js